import React from 'react';
import GridIcon from 'assets/svg/layout-grid.svg';
import GridActiveIcon from 'assets/svg/layout-grid-active.svg';
import ListIcon from 'assets/svg/layout-list.svg';
import ListActiveIcon from 'assets/svg/layout-list-active.svg';
import styled from '@emotion/styled';
import withEvents from 'analytics/withEvents';
import { SearchViewMode } from 'components/list-view-switcher/constants';
import { SearchViewSwitcherProps } from '.';


const ListViewSwitcherWrapper = styled.div`
  display: flex;
`;

const ListViewSwitcherItem = styled.div`
  ${({ theme }) => `
    margin: 0 ${theme.spacing(0.5)};
  `}
  cursor: pointer;
`;

// tslint:disable-next-line: no-empty-interface
export interface ListViewSwitcherProps extends SearchViewSwitcherProps {}

const ListViewSwitcher: React.FC<ListViewSwitcherProps> = ({ mode, setMode, onClick }) => {
  const isGrid = mode === SearchViewMode.Grid;
  const onToggleClick = (view: SearchViewMode) => {
    onClick(view);
    setMode(view);
  };

  const setGridMode = () => onToggleClick(SearchViewMode.Grid);
  const setListMode = () => onToggleClick(SearchViewMode.List);

  const listMode = (
    <ListViewSwitcherItem onClick={setListMode}>
      {isGrid ? <ListIcon /> : <ListActiveIcon />}
    </ListViewSwitcherItem>
  );

  const gridMode = (
    <ListViewSwitcherItem onClick={setGridMode}>
      {isGrid ? <GridActiveIcon /> : <GridIcon />}
    </ListViewSwitcherItem>
  );

  return (
    <ListViewSwitcherWrapper>
      {listMode}
      {gridMode}
    </ListViewSwitcherWrapper>
  );
};

export default withEvents<ListViewSwitcherProps>(sendEvent => ({
  onClick: (view) => sendEvent('search_card_type_toggle_click', 'search', {
    event: {
      'card_type_selected': view === SearchViewMode.Grid ? 'square' : 'list',
    },
  }),
}))(ListViewSwitcher);
